import { type ReactNode } from 'react'
import { Icon } from '@iconify/react'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 p-12 flex-col justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            src="/logo.jpg"
            alt="G-Wiz"
            className="w-10 h-10 rounded-xl object-cover"
          />
          <span className="font-display font-bold text-2xl text-white">G-Wiz</span>
        </div>

        {/* Feature highlights */}
        <div className="space-y-8">
          <h1 className="font-display text-4xl font-bold text-white leading-tight">
            ระบบติดตาม
            <br />
            การจัดซื้อจัดจ้างภาครัฐ
          </h1>
          <p className="text-blue-100 text-lg max-w-md">
            ติดตาม วิเคราะห์ และไม่พลาดโอกาสทางธุรกิจจากการจัดซื้อจัดจ้างภาครัฐทั่วประเทศ
          </p>

          {/* Features */}
          <div className="space-y-4">
            <FeatureItem
              icon="solar:magnifer-zoom-in-line-duotone"
              title="ค้นหาอัจฉริยะ"
              description="ค้นหาประกาศที่เกี่ยวข้องด้วยตัวกรองและ AI"
            />
            <FeatureItem
              icon="solar:bell-line-duotone"
              title="อัปเดตแบบเรียลไทม์"
              description="รับการแจ้งเตือนเมื่อมีประกาศที่ตรงกับเกณฑ์"
            />
            <FeatureItem
              icon="solar:chart-line-duotone"
              title="ข้อมูลเชิงลึกตลาด"
              description="วิเคราะห์แนวโน้มและกิจกรรมคู่แข่ง"
            />
          </div>
        </div>

        {/* Footer */}
        <p className="text-blue-200 text-sm">
          © {new Date().getFullYear()} G-Wiz. สร้างเพื่อความโปร่งใสในการจัดซื้อจัดจ้างภาครัฐ
        </p>
      </div>

      {/* Right side - auth form */}
      <div className="flex-1 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="lg:hidden flex items-center justify-center gap-3 mb-8">
            <img
              src="/logo.jpg"
              alt="G-Wiz"
              className="w-10 h-10 rounded-xl object-cover"
            />
            <span className="font-display font-bold text-2xl text-slate-900">G-Wiz</span>
          </div>

          {children}
        </div>
      </div>
    </div>
  )
}

function FeatureItem({
  icon,
  title,
  description,
}: {
  icon: string
  title: string
  description: string
}) {
  return (
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 rounded-lg bg-white/10 backdrop-blur flex items-center justify-center flex-shrink-0">
        <Icon icon={icon} className="w-5 h-5 text-white" />
      </div>
      <div>
        <h3 className="font-semibold text-white">{title}</h3>
        <p className="text-blue-100 text-sm">{description}</p>
      </div>
    </div>
  )
}
